import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getContactStatements = async (ID, fromDate, toDate) => {
    const transactions = await Axios.get(`/contacts/statement/${ID}?fromDate=${fromDate}&toDate=${toDate}`);
    return transactions;
};

const useContactStatements = (ID, fromDate, toDate) => {
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['contactStatements', intID, fromDate, toDate],
        queryFn: () => getContactStatements(intID, fromDate, toDate),
        staleTime: 60000,
        cacheTime: 60000,
        enabled: !disableQuery,
        retry: false,
    });
};

const forceReloadContactStatements = (ID, fromDate, toDate) => {
    const intID = Number(ID);
    if (fromDate && toDate) {
        queryClient.invalidateQueries({ queryKey: ['contactStatements', intID, fromDate, toDate] });
    } else {
        queryClient.invalidateQueries({ queryKey: ['contactStatements', intID] });
    }
};

export { useContactStatements, forceReloadContactStatements };
